module.exports = __webpack_public_path__ + "static/media/veryvell_black_iced_tea.367ecdf7.png";